export function hasSelectedPower(power) {
    if (!power) {
        return false;
    }
    if (power.isSelected) {
        return true;
    }
    const children = Array.isArray(power.powerList) ? power.powerList : [];
    return children.some(child => hasSelectedPower(child));
}

export function getPowerCodeWithChildren(list, code) {
    if (code == null || code === "") {
        return true;
    }
    if (!Array.isArray(list)) {
        return null;
    }
    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.powerCode == code && hasSelectedPower(item)) {
            return item;
        }
        const temp = getPowerCodeWithChildren(item.powerList, code);
        if (temp) {
            return temp;
        }
    }
    return null;
}

export function filterSelectedRouteChildren(list) {
    if (!Array.isArray(list)) {
        return [];
    }
    return list.filter(item => hasSelectedPower(item) && item.routePath);
}
